module.exports = __webpack_public_path__ + "img/5.4fe2d1c3.jpg";